<template>
  <section class="rechargeRecord">
    <header-com/>
    <div class="topWrap">
      <h5 class="grey9 f24">我的余额(元)</h5>
      <h2 class="bold">{{customerInfo.balance}}</h2>
    </div>
    <div class="content" :class='{centers:list.length == 0}'>
      <ul v-if='list.length > 0'>
        <li v-for="(item, index) in list" :key="index">
          <h2 class="bold"><span class="grey6 f28">{{item.recordTypeText}}</span><span class="f40">{{item.amountText}}</span></h2>
          <h3 class="f24 grey9"><time>{{item.createTime}}</time><span>{{item.currentBalance}}</span></h3>
        </li>
      </ul>
      <div v-else>
       <img src='/images/base/norechage.png' class='no-list'>
      </div>
    </div>
  </section>
</template>

<script>
  import myApi from '@/axios/my'
  export default {
    name: 'rechargeRecord',
    data () {
      return {
        list: [],
        customerInfo: {}
      }
    },
    watch: {},
    computed: {},
    created () {
      this.balanceRecord();
      this.getBaseInfo();
    },
    mounted () {
    },
    methods: {
      balanceRecord(){
        myApi.balanceRecord().then((res)=>{
          this.list = res;
        })
      },
      getBaseInfo(){
        myApi.customerInfo().then((res)=>{
          this.customerInfo = res;
        })
      },
    }

  }
</script>

<style lang="scss" scoped>
.centers{
  display: flex;
  align-items: center;
}
.no-list{
  width:100%;
  margin-top: 0px;
}
.rechargeRecord{
  padding: 128px 0 0;
  display: flex;
  flex-direction: column;
  .topWrap{
    padding: 0 40px 50px;
    h5{
      line-height: 34px;margin-bottom: 20px;
    }
    h2{
      line-height: 140px;font-size: 100px;
      letter-spacing: -1px;
    }
  }
  .content{
    padding: 0 20px;
    min-height: 900px;
    box-shadow: $base-shadow;
    margin-left:30px;
    margin-right:30px;  
    ul{
      min-height: 1034px;
      padding: 0 34px;
      // box-shadow: $base-shadow;
      border-radius: $base-radius $base-radius 0 0;
      li{
        border-bottom: 2px $border-color dashed;
        padding: 40px 6px;
        h2,h3{
          display: flex;
          justify-content: space-between;
        }
        h2{
          line-height: 56px;margin-bottom: 2px;
        }
        h3{
          line-height: 34px;
        }
      }
    }
  }
}
</style>
